export const LAYOUT_TYPES = {
  '264A': '264A',
  '461A': '461A',
  '461B': '461B',
  '463A': '463A',
  '463B': '463B',
  '464A': '464A',
  '464B': '464B',
  '466A': '466A',
  '466B': '466B',
  '468B': '468B',
};
export const THEME_TYPES = {
  'school-green': 'school-green',
  'school-pink': 'school-pink',
  'school-yellow': 'school-yellow',
  'sugar-rush': 'sugar-rush',
  'sun-flower': 'sun-flower',
  unicorn: 'unicorn',
  'national-day': 'national-day',
  'milk-cat': 'milk-cat',
  'i-love-sea': 'i-love-sea',
  'poclet-cake': 'poclet-cake',
  heart: 'heart',
  floral: 'floral',
  diamond: 'diamond',
  clover: 'clover',
  butterfly: 'butterfly',
  red: 'red',
  blue: 'blue',
  pink: 'pink',
  orange: 'orange',
  black: 'black',
};
export const FRAME_TYPES = {
  '24': '24',
  '46': '46',
};

export const SHOOTING_TYPES = {
  ERROR: 0,
  COUNTDOWN: 1,
  BY_REMOTE: 2,
};

export const BOOTH_CONFIG_DEFAULT = {
  IS_USE_PAY_MOMO: true,
  IS_USE_PAY: true,
  TIME_COUNT_DOWN: 10,
  PORT_BILL_ACCEPTOR: 'COM3',
  PORT_QR_BOX: 'COM4',
  FROMTIME: '10:00:00',
  TOTIME: '12:00:00',
  NUMBER_OF_USE: 1,
};

export const ALBUM_RESOURCE_TYPES = {
  BOOTH_IMAGES: 3,
  VIDEO: 2,
  UPLOAD_IMAGES: 1,
};
